<template>
    <lnb class="lnb--all-opacity-black">
        <template v-for="(_, slotName) in $slots" #[slotName]>
            <slot :name="slotName" />
        </template>
    </lnb>
</template>

<script>
import Lnb from "@/components/publish/styles/headers/lnb.vue";

export default {
    props: {},
    components: {
        Lnb,
    },
    data() {
        return {};
    },
    mounted() {},
    methods: {},
};
</script>

<style lang="scss">
// 사용시 주석을 풀어 사용합니다.
.header__bg {
    background-color: rgba(0, 0, 0, 0.5) !important;
    border: none;
}
</style>
<style lang="scss" scoped>
.lnb--all-opacity-black::v-deep {
    line-height: 1.3;
    padding: 18px 0;
    background-color: transparent;
    > li {
        > a {
            font-weight: 500;
            color: rgba(255, 255, 255, 0.5);
            padding: 6px;
            &:hover {
                color: rgba(255, 255, 255, 1);
            }
        }
    }
}
</style>
